module.exports = __webpack_public_path__ + "img/moving.444cf8d0.svg";